export default function RightArrowIcon() {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
    <svg
      width="9"
      height="7"
      viewBox="0 0 9 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.17021 0L9 3.5L5.17021 7H3.33191L6.49787 4.10667H0L0 2.89333L6.49787 2.89333L3.33191 0L5.17021 0Z"
        fill="#131313"
      />
    </svg>
  );
}
